import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Icon } from '@bingads-webui-react/fabric-control';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { videoIcon } from '../../asset-images';

import { getGridDecorativeLabelStyle } from '../styles/tiles-grid-cell-decorative-label';

const CellDecorativeLabel = ({
  text,
  iconName,
  secondaryText,
  classes,
  additionaIconName,
  additionalText,
}) => (
  <div className={classnames('cell-decorative-label-container', classes.tilesGridCellDecorativeLabel, classes.cellLabel || classes.cellLabelDisplay)}>
    {
      (text || iconName) && (
        <div className={classnames('label-icon-and-text', classes.iconTextWrapper)}>
          {iconName && <Icon className="label-icon" iconName={iconName} />}
          {text && <div>{text}</div>}
        </div>
      )
    }
    {secondaryText && <div className="label-secondary-text">{secondaryText}</div>}
    {
      additionaIconName && (
        <div className="additional-icon-content">
          <img src={videoIcon} className="additional-icon" alt="" />
        </div>
      )
    }
    {
      additionalText && (
        <div className="label-additional-text">
          <div className="label-additional-content" aria-label={additionalText} role="presentation">{additionalText}</div>
        </div>
      )
    }
  </div>
);

CellDecorativeLabel.propTypes = {
  text: PropTypes.string,
  iconName: PropTypes.string.isRequired,
  additionaIconName: PropTypes.string,
  secondaryText: PropTypes.string,
  classes: PropTypes.shape({
    cellLabel: PropTypes.string,
    iconTextWrapper: PropTypes.string,
    tilesGridCellDecorativeLabel: PropTypes.string,
    cellLabelDisplay: PropTypes.string,
  }),
  additionalText: PropTypes.string,
};

CellDecorativeLabel.defaultProps = {
  text: null,
  secondaryText: '',
  classes: {},
  additionalText: null,
  additionaIconName: null,
};

export const TilesGridCellDecorativeLabel
  = withDefaultStyles(CellDecorativeLabel, getGridDecorativeLabelStyle);
